<template>
  <div class="divide-y divide-gray-200">
    <div class="py-6 px-4 flex justify-between">
      <h4 class="font-semibold text-lg text-gray-800">Visibility</h4>

      <fieldset class="space-x-5 flex items-center">
        <div v-for="option in visibilityOptions"
          :key="option.id"

          class="relative flex items-start"
        >
          <div class="flex items-center h-5">
            <input v-model="option.value" :id="option.id" :aria-describedby="`${option.id}-description`" :name="option.id" type="checkbox" class="focus:ring-blue-600 h-4 w-4 text-blue-600 border-gray-300 rounded">
          </div>
          <div class="ml-3 text-sm">
            <label :for="option.id" class="font-medium text-gray-700">{{ option.name }}</label>
          </div>
        </div>
      </fieldset>
    </div>
    <ColorSwatch
      v-if="showingColors"

      class="w-full"
      :prefix="id"

      @click="resetColorChanges"
    />
  </div>
</template>

<script>

import ColorSwatch from "@/components/SideEditor/BlockConfiguration/ColorSwatch/ColorSwatch"

import { mapGetters } from "vuex"

export default {
  props: ['id', 'role', 'config'],
  components: {
    ColorSwatch,
  },
  data() {
    return {
      showingColors: true,
      visibilityOptions: [
        {
          name: "Mobile",
          id: "mobile-hidden",
          value: true,
        },
        {
          name: "Tablet",
          id: "tablet-hidden",
          value: true,
        },
        {
          name: "Desktop",
          id: "desktop-hidden",
          value: true,
        },
      ],
    }
  },
  created() {
    const classes = (this.config && this.config.visibilityClasses) || []
    console.warn(classes)
    classes.forEach(type => {
      const item = this.visibilityOptions.find(item => item.id === type)
      if (item) item.value = false
    })
  },
  methods: {
    resetColorChanges() {
      this.showingColors = false
      this.$nextTick(() => requestAnimationFrame(() => this.showingColors = false))
    },
  },
  computed: {
    ...mapGetters({
      page: "editor/page",
    }),

    visibility() {
      return this.visibilityOptions
        .filter(item => !item.value)
        .map(item => item.id)
    },
  },
  watch: {
    visibility(val) {
      const conf = {}
      // if (val.length) conf.visibilityClasses = val
      conf.visibilityClasses = val.length ? [...val.length] : []

      console.warn("setBlockConfig: ", "visibility")
      this.$store.dispatch('editor/setBlockConfig', {
        id: this.id,
        role: this.role,
        config: conf,
      })
    },
  },
}

</script>
